import { Component, Input, inject } from '@angular/core';
import { AuthService } from '../../../../shared';
import { Router } from '@angular/router';
import { GaService, ProductService } from '../../../../services';
import { RESTOCK_ALERT_UI_TEMP_DISABLED } from '../../../../common/composables/restock-alert.helper';

@Component({
  selector: 'app-my-navigation',
  templateUrl: './my-navigation.component.html',
  styleUrls: ['./my-navigation.component.scss'],
  standalone: false,
})
export class MyNavigationComponent {
  private router = inject(Router);
  private authService = inject(AuthService);
  private gaService = inject(GaService);
  private productService = inject(ProductService);

  @Input() currentPage: string;

  /** TEMP: RESTOCK_ALERT_UI_TEMP_DISABLED — 배포 후 제거 */
  readonly restockAlertUiTempDisabled = RESTOCK_ALERT_UI_TEMP_DISABLED;

  signout() {
    this.authService.signout();
    this.productService.selectProducts = [];
    this.gaService.logLogout();
    this.router.navigate(['/signin']);
  }
}
